import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import { Grid, RadioGroup } from 'syf-component-library/ui/patterns';
import MULTI_PAYMENT_FLOW_TABS from '../../../../const/multiPaymentFlowTabs';
import { paymentTypes } from '../../../../const/paymentOptions';
import MainContext from '../../../../Context';
import { getPaymentMethodsFromPaymentEnterpriseEligibility, isRevolvingCreditProduct } from '../../../../helpers';
import { getPaymentTypeError } from '../../../../helpers/getPaymentMethodErrorMessage';
import useApiMachine from '../../../../hooks/machines/useApiMachine';
import usePaymentFlowMachine from '../../../../hooks/machines/usePaymentFlowMachine';
import PaymentMethodSelectorOption from './PaymentMethodSelectorOption';
const PaymentMethodRadioGroup = styled(RadioGroup) `
  flex-wrap: wrap;
  gap: ${spacing.base}px;
`;
const PaymentMethodTypeSelector = ({ errorMessage, featureFlags, paymentMethodType, productType, handlePaymentMethodTypeChange }) => {
    var _a;
    const { additionalProps, multiPaymentFlowCurrentTab } = useContext(MainContext);
    const [apiMachine] = useApiMachine();
    const { data: paymentEnterpriseEligibility } = apiMachine.context.paymentEnterpriseEligibilityQueryResult;
    const paymentTypeError = getPaymentTypeError(errorMessage);
    const [paymentFlow] = usePaymentFlowMachine();
    const isAutopayFlow = paymentFlow === paymentTypes.AUTOPAY;
    const shouldFilterDebitCard = (isAutopayFlow && isRevolvingCreditProduct(productType)) ||
        (((_a = additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.flow) === null || _a === void 0 ? void 0 : _a.type) === 'MULTI_PAYMENT_FLOW' &&
            multiPaymentFlowCurrentTab === MULTI_PAYMENT_FLOW_TABS.MULTI);
    const paymentMethodOptions = getPaymentMethodsFromPaymentEnterpriseEligibility(productType, paymentEnterpriseEligibility, featureFlags).filter((method) => shouldFilterDebitCard ? method !== 'PINLESS_DEBIT_CARD' : method);
    if (paymentMethodOptions.length === 1)
        return null;
    return (_jsx(Grid, { children: _jsx(PaymentMethodRadioGroup, Object.assign({ "aria-label": "payment-method-options", dataCy: "payment-method-types", direction: "row", radioType: "chip", selected: paymentMethodType, onChange: handlePaymentMethodTypeChange }, { children: paymentMethodOptions.map((paymentMethod) => {
                return (_jsx(PaymentMethodSelectorOption, { featureFlags: featureFlags, handlePaymentMethodTypeChange: handlePaymentMethodTypeChange, isPaymentTypeError: paymentTypeError === paymentMethod, productType: productType, selected: paymentMethodType === paymentMethod, type: paymentMethod }, paymentMethod));
            }) })) }));
};
export default PaymentMethodTypeSelector;
